module.exports = __webpack_public_path__ + "static/media/expel-light-mode.2fb99293.png";